export default "__VITE_ASSET__f4aac340__"